import React, { useState } from 'react';
import { Shield, Ban, Trash2, Search } from 'lucide-react';

const UserManagement = ({ 
  users, 
  onDeleteUser, 
  onToggleAdmin, 
  onBanCommenting 
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredUsers = users.filter(u => 
    u.username?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    u.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="bg-white/5 backdrop-blur-xl border border-white/20 rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">User Management</h3>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search users..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10 pr-4 py-2 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-electric"
            data-testid="user-search-input"
          />
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/10">
              <th className="text-left py-3 px-4 text-muted-foreground font-medium">User</th>
              <th className="text-left py-3 px-4 text-muted-foreground font-medium">Email</th>
              <th className="text-left py-3 px-4 text-muted-foreground font-medium">Status</th>
              <th className="text-left py-3 px-4 text-muted-foreground font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.id} className="border-b border-white/5">
                <td className="py-3 px-4">
                  <p className="text-foreground font-medium">{user.username}</p>
                </td>
                <td className="py-3 px-4 text-muted-foreground">{user.email}</td>
                <td className="py-3 px-4">
                  <div className="flex space-x-2">
                    {user.is_admin && (
                      <span className="px-2 py-1 bg-purple-500/20 text-purple-400 text-xs rounded-full">Admin</span>
                    )}
                    {user.is_premium && (
                      <span className="px-2 py-1 bg-electric/20 text-electric text-xs rounded-full">Premium</span>
                    )}
                    {!user.can_comment && (
                      <span className="px-2 py-1 bg-red-500/20 text-red-400 text-xs rounded-full">Banned</span>
                    )}
                  </div>
                </td>
                <td className="py-3 px-4">
                  <div className="flex space-x-2">
                    <button
                      onClick={() => onToggleAdmin(user.id, user.is_admin)}
                      className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                      title={user.is_admin ? 'Remove Admin' : 'Make Admin'}
                      data-testid={`toggle-admin-${user.id}`}
                    >
                      <Shield className={`h-4 w-4 ${user.is_admin ? 'text-purple-400' : 'text-muted-foreground'}`} />
                    </button>
                    <button
                      onClick={() => onBanCommenting(user.id, user.can_comment)}
                      className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                      title={user.can_comment ? 'Ban Commenting' : 'Unban Commenting'}
                      data-testid={`ban-user-${user.id}`}
                    >
                      <Ban className={`h-4 w-4 ${!user.can_comment ? 'text-red-400' : 'text-muted-foreground'}`} />
                    </button>
                    <button
                      onClick={() => onDeleteUser(user.id)}
                      className="p-2 hover:bg-red-500/20 rounded-lg transition-colors text-red-400"
                      title="Delete User"
                      data-testid={`delete-user-${user.id}`}
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredUsers.length === 0 && (
          <p className="text-center text-muted-foreground py-8">No users found</p>
        )}
      </div>
    </div>
  );
};

export default UserManagement;
